import React from "react";
import { Star } from "lucide-react";

export const StarRow = ({ value, size = 18 }) => (
  <div className="flex gap-0.5" aria-label={`${value} / 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        className={i <= value ? "fill-terracotta text-terracotta" : "text-line"}
      />
    ))}
  </div>
);

export const StarPicker = ({ value, onChange }) => {
  const [hover, setHover] = React.useState(0);
  return (
    <div className="flex gap-1" data-testid="star-picker">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          data-testid={`star-${i}`}
          onMouseEnter={() => setHover(i)}
          onMouseLeave={() => setHover(0)}
          onClick={() => onChange(i)}
          className="transition-transform hover:scale-110"
        >
          <Star
            size={32}
            className={i <= (hover || value) ? "fill-terracotta text-terracotta" : "text-line"}
          />
        </button>
      ))}
    </div>
  );
};
